import { render } from "./AssociatedTours.vue?vue&type=template&id=645051a3"
import script from "./AssociatedTours.vue?vue&type=script&lang=js"
export * from "./AssociatedTours.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "645051a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('645051a3', script)) {
    api.reload('645051a3', script)
  }
  
  module.hot.accept("./AssociatedTours.vue?vue&type=template&id=645051a3", () => {
    api.rerender('645051a3', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/AssociatedTours.vue"

export default script